// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  padding: 15px 20px;
  box-shadow: 0 10px 30px 0 rgba(121, 121, 162, 0.1019607843);
  display: flex;
  justify-content: flex-end;
  background-color: var(--anchor-wrapper-bg);
  margin-bottom: 20px;
}
.header .wrapper {
  width: max-content;
  display: flex;
  align-items: center;
  gap: 30px;
}

button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.themeChanger {
  display: flex;
  align-items: center;
  justify-content: center;
}

.languageChanger {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.languageChanger .text {
  display: block;
  font-weight: 500;
  font-size: 16px;
  line-height: 12px;
  letter-spacing: -0.3px;
  text-transform: uppercase;
}

.profile {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.profile .info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}
.profile .info .fullName {
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: -0.3px;
  margin-bottom: 2px;
  text-align: center;
}
.profile .info .role {
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: -0.3px;
  color: #898989;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/header.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,2DAAA;EACA,aAAA;EACA,yBAAA;EACA,0CAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAGA;EACE,6BAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAAF;AAEE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AADJ;AAGI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AADN;AAII;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAFN","sourcesContent":[".header {\n  width: 100%;\n  padding: 15px 20px;\n  box-shadow: 0 10px 30px 0 #7979a21a;\n  display: flex;\n  justify-content: flex-end;\n  background-color: var(--anchor-wrapper-bg);\n  margin-bottom: 20px;\n\n  .wrapper {\n    width: max-content;\n    display: flex;\n    align-items: center;\n    gap: 30px;\n  }\n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n}\n\n.themeChanger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.languageChanger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n\n  .text {\n    display: block;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 12px;\n    letter-spacing: -0.3px;\n    text-transform: uppercase;\n  }\n}\n\n.profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n\n  .info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 4px;\n\n    .fullName {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 14px;\n      letter-spacing: -0.3px;\n      margin-bottom: 2px;\n      text-align: center;\n    }\n\n    .role {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 14px;\n      letter-spacing: -0.3px;\n      color: #898989;\n      text-align: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
